import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
// ------------------ list Product-------
const getAllBrand = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.brand.list + `${filter ? '?' + filter : ''}`);

    return data;
};
const GetAllBrandQuery = (filter) => {
    return useQuery(['Brand',filter], () => getAllBrand(filter));

};
// ------------------ Add Product-------
const addBrand = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.brand.add, payload);
};
const AddBrandMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addBrand, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Brand');
            toastMessage('success', 'Brand Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Update Brand -------
const updateBrand = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.brand.update + id, payload);
};
const UpdateBrandMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateBrand, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Brand');
            toastMessage('success', 'Brand Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

// ------------------ Delete Brand -------
const deleteBrand = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.brand.delete + id);
};
const DeleteBrandMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteBrand, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Brand');
            toastMessage('success', 'Brand Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllBrandQuery, AddBrandMutation, DeleteBrandMutation, UpdateBrandMutation };
